import React from "react";
import { Modal, Button } from "reactstrap";
import { uploadFileAndGetKey } from "../utils/fileUtils"; // <-- reuse service

const FilePreviewModal = ({
  showModal,
  setShowModal,
  previewUrl,
  setPreviewUrl,
  selectedFile,
  setSelectedFile,
  folderName = "chat_attachments",
  onUploadSuccess,
}) => {
  const [uploading, setUploading] = React.useState(false);

  const handleSendFile = async () => {
    if (!selectedFile) return;
    setUploading(true);

    try {
      // Upload file and get fileKey
      const fileKey = await uploadFileAndGetKey(selectedFile, folderName);

      // Notify parent
      if (onUploadSuccess) {
        onUploadSuccess(fileKey);
      }

      // Reset state
      setShowModal(false);
      setPreviewUrl("");
      setSelectedFile(null);
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
      <div className="p-3">
        {previewUrl && (
          <img src={previewUrl} alt="preview" style={{ maxWidth: "100%" }} />
        )}
        <div className="mt-3 d-flex gap-2">
          {uploading ? (
            <Button color="primary" disabled>
              Sending...
            </Button>
          ) : (
            <Button color="primary" onClick={handleSendFile}>
              Send
            </Button>
          )}
          <Button
            color="secondary"
            onClick={() => {
              setShowModal(false);
              setPreviewUrl("");
              setSelectedFile(null);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FilePreviewModal;
